import { IEventReplay, IDemo } from 'types'
import {
  mecExplainer,
  iceMobility,
  jigspace,
  osirix,
  transformationOfHealthcare,
  speedOfThought,
  mecAndSmartVenues,
  transformingTheFanExperience,
  shotTracker,
  indy
} from './demos/'

import { getSharedAsset } from './utils'

export const Demos: IDemo[] = [
  mecExplainer,
  iceMobility,
  jigspace,
  osirix,
  transformationOfHealthcare,
  speedOfThought,
  mecAndSmartVenues,
  transformingTheFanExperience,
  shotTracker,
  indy
]

export const EventReplays: IEventReplay = {
  fullShow: {
    id: 'fullShow',
    title: 'Watch our 2.24 event replay.',
    subtitle: 'Verizon and DOD experts discuss how mission critical outcomes can be supported by 5G.',
    next: 'keynote',
    poster: getSharedAsset('ps1-replay-full.png', 'eventReplay', 'posters'),
    thumbnail: getSharedAsset('ps1-replay-full.png', 'eventReplay', 'thumbnails'),
    videoSrc: getSharedAsset('ps1-replay-full.mp4', 'eventReplay', 'videos')
  },
  keynote: {
    id: 'keynote',
    title: 'Learn from our experts.',
    subtitle:
      'Verizon’s Andrés Irlando, Jennifer Chronis and Mike Haberman discuss Verizon’s commitment to the military, define the different iterations of 5G and explain why it matters to the DOD.',
    next: 'panelDiscussion',
    poster: getSharedAsset('ps1-replay-keynote.png', 'eventReplay', 'posters'),
    thumbnail: getSharedAsset('ps1-replay-keynote.png', 'eventReplay', 'thumbnails'),
    videoSrc: getSharedAsset('ps1-replay-keynote.mp4', 'eventReplay', 'videos')
  },
  panelDiscussion: {
    id: 'panelDiscussion',
    title: '5G and the U.S. Marine Corps: How Miramar is becoming a proving ground for new use cases.',
    subtitle:
      'In this panel, experts discuss the path one military base took to deploy 5G and how it is being used to support their strategic initiatives.',
    next: 'fullShow',
    poster: getSharedAsset('ps1-replay-panel.png', 'eventReplay', 'posters'),
    thumbnail: getSharedAsset('ps1-replay-panel.png', 'eventReplay', 'thumbnails'),
    videoSrc: getSharedAsset('ps1-replay-panel.mp4', 'eventReplay', 'videos')
  }
}
